<template>
  <ContactForm :open="openContactForm" @hide-modal="hideContactForm" />
  <p class="mt-4 mb-20 text-center" v-if="!!userStore?._distributor?.customerservice.email">
    {{ $t("Questions about your tickets? Please contact") }}
    <button class="underline" @click="openContactForm = true">{{
      userStore._distributor?.customerservice.trade_name || userStore._distributor.distributor_name
    }}</button
    >.
  </p>
  <p class="mt-4 mb-20 text-center" v-else>
    {{ $t("Questions about your tickets? Please contact") }}
    <button class="underline" @click="openContactForm = true">{{ $t("our support team") }}</button
    >.
  </p>
</template>

<script setup>
import { ref } from "vue";
import { useUserStore } from "@/store/user.js";
import ContactForm from "@/components/ContactForm.vue";

const userStore = useUserStore();
const openContactForm = ref(false);

const hideContactForm = () => {
  openContactForm.value = false;
};
</script>
